import { Component, inject, type OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SettingsService } from '../settings.service';

@Component({
  selector: 'app-toggle-tracking',
  templateUrl: './toggle-tracking.component.html',
  styleUrls: ['./toggle-tracking.component.scss'],
  standalone: false,
})
export class ToggleTrackingComponent implements OnInit {
  private snackBar = inject(MatSnackBar);
  private settingsService = inject(SettingsService);

  initialChecked: boolean;

  ngOnInit() {
    this.initialChecked = this.settingsService.getTrackingOption();
  }

  toggleTracking(event) {
    this.settingsService.updateTracking(event.checked);
    this.snackBar.open(
      'Page will be automatically refreshed to apply the changes',
      'Dismiss',
      {
        duration: 2500,
        verticalPosition: 'top',
        horizontalPosition: 'right',
      }
    );
    setTimeout(() => {
      location.reload();
    }, 3000);
  }
}
